export const checkoutConstants = {
  SET_BASKET_ITEMS: 'SET_BASKET_ITEMS',
  CLEAR_BASKET_ITEMS: 'CLEAR_BASKET_ITEMS',
};
